import { Box, Button } from "@chakra-ui/react";
import {
  AuthFactorInfo,
  AuthFactorInfos,
  AuthFactorInstance,
} from "features/auth/AuthFactor";
import React from "react";

interface AuthFactorButtonProps {
  info: AuthFactorInfo;
  onClick: (info: AuthFactorInfo) => void;
}

export const AuthFactorButton: React.FC<AuthFactorButtonProps> = ({
  onClick,
  info,
}) => (
  <Button
    colorScheme="secondary"
    justifyContent="flex-start"
    leftIcon={React.createElement(info.icon, {
      width: "20px",
      height: "20px",
    })}
    onClick={() => onClick(info)}
  >
    {info.name}
  </Button>
);

export const AuthFactorInstanceButton: React.FC<{
  instance: AuthFactorInstance;
  onClick: (info: AuthFactorInstance) => void;
}> = ({ instance, onClick }) => {
  const info = AuthFactorInfos[instance.type];
  return (
    <Button
      colorScheme="secondary"
      justifyContent="flex-start"
      leftIcon={React.createElement(info.icon, {
        width: "20px",
        height: "20px",
      })}
      onClick={() => onClick(instance)}
    >
      {info.name}
      {instance.name && (
        <Box flex={1} fontWeight="normal" textAlign="right" color="gray.400">
          {instance.name}
        </Box>
      )}
    </Button>
  );
};
